import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Modal, Dropdown, DropdownButton } from "react-bootstrap";
import swal from "sweetalert";
import NoRowsOverlay from "../../../components/NoRowsOverlays";
import { fetch4, httpAdmin } from "../../../Apis/commonApis";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { useForm, Controller } from "react-hook-form";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { ShowSwal } from "../../../utils/alertSwal";
import { disablePastDate } from "../../../utils/CommonFunctions";

const columns = [
  {
    field: "year",
    headerName: "Year",
    width: 90,
  },
  {
    field: "fromDate",
    headerName: "From (date)",
    width: 150,
    editable: true,
  },
  {
    field: "toDate",
    headerName: "To (date)",
    width: 150,
    editable: true,
  },
  {
    field: "approvedBy",
    headerName: "Approved By",
    width: 150,
    editable: true,
  },
];

const Holiday = (props) => {
  const { careteamId, Profileaccess, getCareTeambyId } = props;
  let params = useParams();

  const {
    register,
    handleSubmit,
    unregister,
    setValue,
    watch,
    reset,
    formState: { errors },
    control,
  } = useForm();

  const careSiteId = currentCareSiteId;
  const [isOpen, setIsOpen] = useState("");
  const [ids, setIDs] = useState([]);
  const [holidaysData, setHolidaysData] = useState([]);
  const [holidayDetails, setHolidayDetails] = useState(null);

  // Multiple row selection
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  useEffect(() => {
    setIDs(rowSelectionModel);
  }, [rowSelectionModel]);

  useEffect(() => {
    getHolidaysData();
  }, []);

  const getHolidaysData = () => {
    axios({
      url: `${process.env.REACT_APP_BASEURL}/getLeaves?careSiteId=${careSiteId}&careTeamId=${careteamId}`,
      method: "GET",
      headers: { Authorization: localStorage.getItem("care_admin_token") },
    })
      .then((res) => {
        let holidaydata = res.data.data;
        let holidayArr = [];
        holidaydata?.forEach((elem) => {
          let approveby = `${elem.approvedBy?.firstName} ${elem.approvedBy?.lastName}`;
          holidayArr.push({
            id: elem._id,
            year: elem?.Date?.from?.slice(0, 4),
            fromDate: elem?.Date?.from,
            toDate: elem?.Date?.to,
            approvedBy: approveby ? approveby : "",
          });
        });
        setHolidaysData(holidayArr);
      })
      .catch((error) => console.log(`Error: ${error}`));
  };

  function resetForm() {
    reset();
    setIsOpen("");
  }
  // =========================  Add and edit Holidays for care team members  ===================== //
  const userData = JSON.parse(localStorage.getItem("userData"));

  function addLeave({ from, to }) {
    let dates = {
      from: from,
      to: to,
    };
    let data = {
      careTeamId: careteamId,
      careSiteId: careSiteId,
      adminId: userData._id,
      dates: dates,
    };
    if (holidayDetails?.id) {
      data.leaveId = holidayDetails?.id;
    }
    let config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/addLeave`,
      headers: {
        Authorization: localStorage.getItem("care_admin_token"),
        "Content-Type": "application/json",
      },
      data: JSON.stringify(data),
    };

    axios(config)
      .then(function (response) {
        swal(
          response.data.status ? "Success" : "Failed",
          response.data.message,
          response.data.status ? "success" : "error"
        ).then((value) => {
          resetForm();
          getHolidaysData();
          getCareTeambyId();
        });
      })
      .catch(function (error) {
        if (error.response) {
          swal("Failed", error.response.data.message, "error");
        } else if (error.request) {
          console.log(error.request);
        } else {
          swal("Failed", error.message, "error");
        }
        console.log(error.config);
      });
  }

  // -----------  Delete Clients Popup (Show and Hide Handler) Starts ------------ //

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const handleCloseDeletePopup = () => setIsDeleteOpen(false);
  const handleShowDeletePopup = () => setIsDeleteOpen(true);

  // ---------------------     delete multiple  api    ----------------------------------  //

  async function deletemultiple() {
    try {
      const result = await fetch4(
        `${process.env.REACT_APP_BASEURL}/deleteLeave`,
        { careTeamId: careteamId, careSiteId: careSiteId, leaveId: ids },
        { Authorization: localStorage.getItem("care_admin_token") }
      );

      swal(
        result.status ? "Success" : "Failed",
        result.message,
        result.status ? "success" : "error"
      ).then((value) => {
        handleCloseDeletePopup();
        getHolidaysData();
        getCareTeambyId();
        return;
      });
    } catch (e) {
      swal("Failed", "Oops, Something went wrong", "error");
    }
  }

  // -----------  Approved Clients Popup (Show and Hide Handler) Starts ------------ //

  const [isApprovedOpen, setIsApprovedOpen] = useState(false);
  const handleCloseApprovedPopup = () => setIsApprovedOpen(false);
  const handleShowApprovedPopup = () => setIsApprovedOpen(true);

  // ---------------------     Approved multiple  api    ----------------------------------  //

  async function approvedmultiple() {
    try {
      const result = await fetch4(
        `${process.env.REACT_APP_BASEURL}/approveLeave`,
        {
          careTeamId: careteamId,
          careSiteId: careSiteId,
          leaveId: ids[0],
          leaveStatus: true,
        },
        { Authorization: localStorage.getItem("care_admin_token") }
      );
      swal(
        result.status ? "Approved" : "Failed",
        result.status ? "Leave Approved Successfully" : result.message,
        result.status ? "success" : "error"
      ).then((value) => {
        handleCloseApprovedPopup();
        getHolidaysData();
        return;
      });
    } catch (e) {
      swal("Failed", "Oops, Something went wrong", "error");
    }
  }

  const handleOpenLeaveModal = (type) => {
    if (type === "edit") {
      if (ids.length === 1) {
        const findSelected = holidaysData.find((mid) => mid.id == ids[0]);
        setValue("from", findSelected?.fromDate ?? "");
        setValue("to", findSelected?.toDate ?? "");
        setHolidayDetails(findSelected);
        setIsOpen(type);
      } else {
        ShowSwal(false, "Please Select at least one client");
      }
    } else {
      setIsOpen(type);
      setHolidayDetails(null);
    }
  };

  return (
    <div className="card_inbox mt-4">
      {/* sShowing Medical Condition */}
      <div className="mb-4 btns_head">
        <h5 className="tb_title mt-0 d-flex justify-content-between">
          Holidays{" "}
          <DropdownButton id="dropdown-basic-button" title="Actions">
            <Dropdown.Item
              // className="btn btn-theme btn-sm float-end"
              onClick={() => handleOpenLeaveModal(null)}
              disabled={Profileaccess !== "full"}
            >
              Add
            </Dropdown.Item>
            {/* <Dropdown.Item
              data-bs-toggle="modal"
              data-bs-target="#edit_medi_cond"
              disabled={Profileaccess !== "full"}
              onClick={() => handleOpenLeaveModal("edit")}
            >
              Edit
            </Dropdown.Item> */}
            <Dropdown.Item
              disabled={Profileaccess !== "full"}
              onClick={() => {
                if (ids.length >= 1) {
                  setHolidayDetails({});
                  handleShowDeletePopup(true);
                } else
                  swal(
                    "Failed",
                    "Please Select at least one client",
                    "error"
                  ).then((value) => {
                    return;
                  });
              }}
            >
              Delete{" "}
            </Dropdown.Item>
          </DropdownButton>
        </h5>
      </div>

      <Box sx={{ height: 300, width: "100%" }}>
        <DataGrid
          rows={holidaysData}
          columns={columns}
          checkboxSelection
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
          rowSelectionModel={rowSelectionModel}
          slots={{
            noRowsOverlay: NoRowsOverlay,
          }}
          onSelectionModelChange={(newRowSelectionModel) => {
            setRowSelectionModel(newRowSelectionModel);
          }}
        />
      </Box>

      {/* add leave */}
      {isOpen !== "" && (
        <Modal show={isOpen !== ""} onHide={resetForm}>
          <Modal.Body>
            <div
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-scrollable">
                <form onSubmit={handleSubmit(addLeave)}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        {isOpen === "edit" ? "Edit" : "Add"} Holiday
                      </h5>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="form-label">From Date</label>
                          <input
                            type="date"
                            className="form-control"
                            min={disablePastDate()}
                            {...register("from", {
                              required: true,
                            })}
                            name="from"
                          />

                          {errors?.from?.type === "required" && (
                            <p className="error_style">
                              This field is required
                            </p>
                          )}
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="form-label">To Date</label>
                          <input
                            type="date"
                            className="form-control"
                            min={disablePastDate(watch("from", ""))}
                            {...register("to", {
                              required: true,
                            })}
                            name="to"
                          />

                          {errors?.to?.type === "required" && (
                            <p className="error_style">
                              This field is required
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={resetForm}
                      >
                        Close
                      </button>
                      <button type="submit" className="btn btn-success">
                        {isOpen === "edit" ? "Save" : "Create"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      {/* delete leave */}
      <Modal
        className="viewModal"
        show={isDeleteOpen}
        onHide={handleCloseDeletePopup}
      >
        <Modal.Header closeButton2>
          <Modal.Title>
            <span>Delete Holiday{ids.length > 1 ? "s" : ""} </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <p>
                  Are you sure you want to delete this{" "}
                  {ids.length > 1 ? "Holidays" : "Holiday"} ?
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <button className="btn submitBtn" onClick={handleCloseDeletePopup}>
              No
            </button>
            <button
              className="btn submitBtn"
              onClick={() => {
                deletemultiple();
              }}
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Approved leave */}
      <Modal
        className="viewModal"
        show={isApprovedOpen}
        onHide={handleCloseApprovedPopup}
      >
        <Modal.Header closeButton2>
          <Modal.Title>
            <span>Approved Holiday{ids.length > 1 ? "s" : ""} </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="">
                <p>
                  Are you sure you want to Approved this{" "}
                  {ids.length > 1 ? "Holidays" : "Holiday"} ?
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex">
            <button
              className="btn submitBtn"
              onClick={handleCloseApprovedPopup}
            >
              No
            </button>
            <button
              className="btn submitBtn"
              onClick={() => {
                approvedmultiple();
              }}
            >
              Yes
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Holiday;
